var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useWebgate } from "@xvia/webgate-connect";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { PontuacaoCnh } from "./PontuacaoCnh";
import axios from "axios";
var schema = yup.object().shape({
    cpf: yup
        .string()
        .length(11, "O CPF deve ter 11 dígitos.")
        .required("CPF é obrigatório"),
    numeroRegistro: yup.string().required("O número do registro é obrigatório"),
});
export var PontuacaoCnhContainer = function () {
    var accessToken = useWebgate().accessToken;
    var _a = React.useState(null), feedback = _a[0], setFeedback = _a[1];
    var _b = React.useState(null), pontuacaoData = _b[0], setPontuacaoData = _b[1];
    var _c = useForm({
        resolver: yupResolver(schema),
    }), register = _c.register, handleSubmit = _c.handleSubmit, errors = _c.formState.errors;
    var fetchPontuacaoCnh = function (cpf, numeroRegistro) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.get("".concat(process.env.REACT_APP_PONTUACAO_API_URL, "/cnh/pontuacao"), {
                        params: { cpf: cpf, numeroRegistro: numeroRegistro },
                        headers: {
                            Authorization: "Bearer ".concat(accessToken),
                            "Content-Type": "application/json",
                        },
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); };
    var onSubmit = function (_a) {
        var cpf = _a.cpf, numeroRegistro = _a.numeroRegistro;
        return __awaiter(void 0, void 0, void 0, function () {
            var data, error_1, errorMessage;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        setFeedback(null);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetchPontuacaoCnh(cpf, numeroRegistro)];
                    case 2:
                        data = _c.sent();
                        setPontuacaoData(data);
                        setFeedback({
                            type: "success",
                            message: data.mensagem,
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _c.sent();
                        setPontuacaoData(null);
                        console.error("Erro ao consultar a pontuação:", error_1);
                        errorMessage = ((_b = error_1.response) === null || _b === void 0 ? void 0 : _b.status) === 404
                            ? "Condutor não encontrado com os dados informados."
                            : "Falha ao consultar a pontuação. Tente novamente.";
                        setFeedback({
                            type: "error",
                            message: errorMessage,
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    var onCloseFeedback = function () {
        setFeedback(null);
    };
    return (_jsx(PontuacaoCnh, { onSubmit: handleSubmit(onSubmit), register: register, errors: errors, feedback: feedback, onCloseFeedback: onCloseFeedback, isAuthenticated: !!accessToken, pontuacao: pontuacaoData }));
};
